// generated from 14 samples

import { z } from "zod";

export const checkoutCompletedEventTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CheckoutCompletedEvent"),
  // null: 13 (92.86%)
  storefront: z.string().nullable(),
});
